// Values alse used in _constants.scss
// SEE: USE_MEDIA
const mobileViewBreakpoint = 480;
const tabletBreakpoint = 768;
const laptopBreakpoint = 1024;
const wideLaptopBreakpoint = 1200;
const desktopBreakpoint = 1440;

/**
 * @example
 * `const largerThanMobile = useMedia(LARGER_THAN_MOBILE);`
 */
export const LARGER_THAN_MOBILE = { minWidth: `${mobileViewBreakpoint}px` };

/**
 * @example
 * `const largerThanTablet = useMedia(LARGER_THAN_TABLET);`
 */
export const LARGER_THAN_TABLET = { minWidth: `${tabletBreakpoint}px` };

/**
 * @example
 * `const largerThanLaptop = useMedia(LARGER_THAN_LAPTOP);`
 */
export const LARGER_THAN_LAPTOP = { minWidth: `${laptopBreakpoint}px` };

/**
 * @example
 * `const largerThanWideLaptop = useMedia(LARGER_THAN_WIDE_LAPTOP);`
 */
export const LARGER_THAN_WIDE_LAPTOP = {
  minWidth: `${wideLaptopBreakpoint}px`,
};

/**
 * @example
 * `const largerThanDesktop = useMedia(LARGER_THAN_DESKTOP);`
 */
export const LARGER_THAN_DESKTOP = { minWidth: `${desktopBreakpoint}px` };

/**
 * This is the default breakpoint for the UI to split between "normal" and
 * "mobile" views.
 *
 * Change which breakpoint is used here to change all breakpoints for the UI.
 * This should make things easier if the client ever wants to increase this
 * value further in future.
 *
 * @note Any change to this value should also be reflected in the SCSS
 * variable: `$mobileViewBreakpoint` (_constants.scss)
 *
 * @example
 * `const largerThanMobileView = useMedia(MOBILE_VIEW_BREAKPOINT);`
 */
export const MOBILE_VIEW_BREAKPOINT = LARGER_THAN_LAPTOP;
